/* src/app/features/taxas-juros/taxa-juros-maxima-agente/taxa-juros-maxima-agente-listagem.component.scss */
.icone-adicionar {
  padding-left: 12px;
  padding-bottom: 12px;
}
/*# sourceMappingURL=taxa-juros-maxima-agente-listagem.component.css.map */
